export default __webpack_public_path__ + "static/black-logo-2be94977c1b1fe67cc3fb2b75d74f61c.png";